import {
  ON_GET_RESCHEDULE_REQUESTS,
  CANCEL_RESCHEDULE_REQUEST_ERROR,
  GET_CANCEL_RESCHEDULE_REQUESTS,
  GET_CANCEL_RESCHEDULE_REQUEST,
  ADD_RESPONSE_CANCEL_RESCHEDULE_REQUEST
} from "../types";
// import axios from "axios";
import customAxios from "../../utils/customAxios";
import setAuthToken from "../../utils/setAuthToken";
import { setAlert } from "../alert";

export const getCancelRescheduleRequests = () => async (dispatch) => {
  try {
    dispatch({
      type: ON_GET_RESCHEDULE_REQUESTS,
    });

    const res = await customAxios.get("/api/admin/request-change-booking?limit=3&sortBy=desc&orderBy=date");
    dispatch({
      type: GET_CANCEL_RESCHEDULE_REQUESTS,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: CANCEL_RESCHEDULE_REQUEST_ERROR,
      payload: { msg: err.response, status: err.response },
    });
  }
};

// get vehicle by id
export const getCancelRescheduleRequestById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: ON_GET_RESCHEDULE_REQUESTS,
    });

    const res = await customAxios.get(`/api/admin/request-change-booking?id=${id}`);
    dispatch({
      type: GET_CANCEL_RESCHEDULE_REQUEST,
      payload: res.data.data.data[0],
    });
  } catch (err) {
    dispatch({
      type: CANCEL_RESCHEDULE_REQUEST_ERROR,
      payload: { msg: err.response, status: err.response },
    });
  }
};

//admin response request
export const addResponseRequest = async (formData) => {
  try {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await customAxios.post("/api/admin/request-change-booking/admin-response", formData, config);
    // dispatch({
    //   type: ADD_RESPONSE_CANCEL_RESCHEDULE_REQUEST,
    //   payload: res.data.data,
    // });
    // dispatch(
    //   setAlert("Successfully send email to customer")
    // );

    return res.data
  } catch (err) {
    // dispatch({
    //   type: CANCEL_RESCHEDULE_REQUEST_ERROR,
    //   payload: { msg: err.response, status: err.response },
    // });
    return err.response?.data ?? { desc: "ERROR", message: err.message };
  }
};